import React, { useState, useEffect } from 'react';
import invitados from 'assets/img/icono_tabla.svg';

const MyGuestsCount = ({ totalinvitados , showGuestButton}) => {
    console.log('totalinvitados', totalinvitados?.data?.items?.invitados);
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginTop:'10px' }}>
                <img src={invitados} style={{ width: '60px', height: '60px' }} alt="Invitados" />
            </div>
            <div style={{ marginLeft: '10px',marginTop:'20px',textAlign:'left' }}>
                <b>{totalinvitados?.data?.items?.invitados ?? 0}</b><br />
                invitados
            </div>
            <div style={{ marginLeft: '20px',marginTop:'20px',textAlign:'left' }}>
                <b>{totalinvitados?.data?.items?.adultos ?? 0}</b> adultos<br />
                <b>{totalinvitados?.data?.items?.niños ?? 0}</b> niños,
                <b>{totalinvitados?.data?.items?.bebes ?? 0}</b> bebés
            </div>
        </div>
    );
}

export default MyGuestsCount;